/**
 * P3-32: Adore 按钮（reset faith）。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useAdoreButtonModel } from "./useReligionModel";
import { t } from "../../bridge/i18n";

interface AdoreButtonProps {
  handler: () => void;
}

export function AdoreButton({ handler }: AdoreButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useAdoreButtonModel(
    t("religion.adoreBtn.label"),
    t("religion.adoreBtn.desc"),
    handler,
  );

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (controller && modelRef.current) {
        controller.buyItem?.(modelRef.current, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
